import React from 'react'

import ModalV4 from "../../../app/ui/modal/v4/v4"
import ItemViewTop from "../../../layout/top/item-view-top/item-view-top"
import Message from "../../model2/message/message"
import MessageEditMain from "./components/main"

type Props = {
    params: {
        message     : Message,
        onSubmit    : {(contentText: string, contentRTF: any, attachments: any):void}
    }
}

class ModalEditMessage extends ModalV4 {

    constructor(props:Props) {
        super(props)
    }

    onClick = (e: React.SyntheticEvent) => {
        e.stopPropagation()
        e.preventDefault()
    }

    onSubmit = (contentText: string, contentRTF: any, attachments: any) => {
        this.props.params.onSubmit(contentText, contentRTF, attachments)
        gd.modal.hide()
    }

    closeModal = () => {
        this.props.params.onCancel()
        gd.modal.hide()
    }

    render() {
        const topLeftContent = <div className="ui5-txt-not-important-small">Edit message</div>

        return (
            <div className="v4-container placement-middle ui5-iv iv-message-edit" onClick={this.onClick}>
                <ItemViewTop leftContent={topLeftContent} onCloseClick={this.closeModal}/>
                <MessageEditMain message    = {this.props.params.message}
                                 onSubmit   = {this.onSubmit}
                                 onCancel   = {this.closeModal}/>
            </div>
        )
    }
}

module.exports = ModalEditMessage
